var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.model.position,
        expression: "model.position",
      },
    ],
    staticClass: "form-control form-control-sm",
    attrs: { min: "0", type: "number" },
    domProps: { value: _vm.model.position },
    on: {
      change: function ($event) {
        return _vm.$parent.$emit("update-position", _vm.model)
      },
      input: function ($event) {
        if ($event.target.composing) {
          return
        }
        _vm.$set(_vm.model, "position", $event.target.value)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }